// import '@/styles/main.sass'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueMask from 'v-mask'
import axios from 'axios'
import VueAxios from 'vue-axios'

import components from '@/components/ui'
// import icons from '@/components/icons'

// let axiosInstanse = axios.create({
//   baseURL: window.bookingController,
//   headers: {
//     'X-Widget-Key': window.bookingApiKey,
//   },
// })

let axiosInstanse = axios.create({
  baseURL: '/booking',
})

Vue.use(VueAxios, axiosInstanse)

Vue.config.productionTip = false

let app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
})

Vue.use(VueMask, {
  placeholders: {
    L: /[а-яА-Я]/,
  }
})

components.forEach(component => {
  Vue.component(component.name, component)
})

// components.forEach(icon => {
//   Vue.component(icon.name, icon)
// })

app.$mount('#bookingWidget')
